import {
  Card,
  Group,
  ThemeIcon,
  Text,
  SimpleGrid,
  Flex,
  Badge,
  Tooltip,
  ActionIcon,
  Progress,
  Skeleton,
} from "@mantine/core";

const getCapacityColor = (current, max) => {
  const percentage = current / max;
  return percentage >= 0.9 ? "red" : "green";
};

function StatCard({ stat, loading = false }) {
  if (loading) {
    return (
      <Card shadow="sm" p="lg" radius="md" withBorder>
        <Group justify="space-between" mb="md" wrap="nowrap">
          <Skeleton height={44} width={44} radius="md" />
          <Group align="center" wrap="nowrap" gap="xs">
            <Skeleton height={24} width={100} />
            <Skeleton height={20} width={20} circle />
          </Group>
        </Group>

        <SimpleGrid cols={3} spacing="xs">
          {[0, 1, 2].map((idx) => (
            <Flex
              key={idx}
              align="center"
              justify="space-between"
              direction="column"
              gap="sm"
            >
              <Skeleton height={16} width={80} />
              <Skeleton height={32} width={50} radius="xl" />
            </Flex>
          ))}
        </SimpleGrid>
      </Card>
    );
  }

  return (
    <Card shadow="sm" p="lg" radius="md" withBorder>
      <Group justify="space-between" mb="md" wrap="nowrap">
        <ThemeIcon size="xl" radius="md" color={stat.color} variant="light">
          {stat.icon}
        </ThemeIcon>
        <Group align="center" wrap="nowrap" gap="xs">
          <Text fw={500} size="lg" lineClamp={1}>
            {stat.title}
          </Text>
          {stat.tooltip && (
            <Tooltip
              label={stat.tooltip.text}
              position="top"
              withArrow
              transition="fade"
              placement="center"
            >
              <ActionIcon
                size="md"
                variant="transparent"
                color="gray"
                radius="xl"
                onClick={stat.tooltip.onClick}
              >
                {stat.tooltip.icon}
              </ActionIcon>
            </Tooltip>
          )}
        </Group>
      </Group>

      <SimpleGrid cols={{ sm: 1, md: stat.details.length }} spacing="xs">
        {!stat.details.length && (
          <Text size="sm" c="dimmed" ta="center">
            No data available
          </Text>
        )}
        {stat.details.map((detail, idx) => (
          <Flex
            align="center"
            justify="space-between"
            key={idx}
            direction="column"
            gap="sm"
            wrap="nowrap"
          >
            <Text
              size="sm"
              c="dimmed"
              lineClamp={1}
              style={{ maxWidth: "100%", textAlign: "center" }}
              title={detail.label}
            >
              {detail.label}
            </Text>

            <Badge size="xl" color={detail.color} radius="xl" variant="light">
              {detail.value}
            </Badge>
          </Flex>
        ))}
      </SimpleGrid>

      {stat.capacity && (
        <Flex direction="column" mt="md">
          <Text size="xs" c="dimmed">
            Capacity: {stat.approvedTickets} / {stat.capacity}
          </Text>

          <Progress
            value={(stat.approvedTickets / stat.capacity) * 100}
            size="md"
            mt={4}
            radius="xl"
            color={getCapacityColor(stat.approvedTickets, stat.capacity)}
          />
        </Flex>
      )}
    </Card>
  );
}

export default StatCard;
